import { JSResourceForInteraction } from '@atlassian/react-async';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

export const workflowSchemeProjectLimitMetricDetailEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-workflow-scheme-project-limit" */ '@jira/spa-apps__admin-pages-performance-metric-detail-workflow-scheme-project-limit/src/WorkflowSchemeProjectLimitDetail.tsx'
				),
		),
		getPreloadProps: () => ({}),
	},
});
